import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BandwidthEmergencyCallingSettingsConfig } from '../../../../shared/models/generated/ziroModels';

@Injectable()
export class BandwidthEmergencyCallingFieldConfigResource {
  protected http = inject(HttpClient);

  get(tenantId: string | number, upn: string, lineUri: string): Observable<BandwidthEmergencyCallingSettingsConfig> {
    const encodedUpn = encodeURIComponent(upn);
    const encodedLineUri = encodeURIComponent(lineUri);
    return this.http.get<BandwidthEmergencyCallingSettingsConfig>(
      `/services/microsoft/teams-user-management/tenants/${tenantId}/field-configs/bandwidth-emergency-calling-settings?upn=${encodedUpn}&lineUri=${encodedLineUri}`,
    );
  }
}
